import angular from 'angular';
import { dynamicSort, dynamicSortMultiple } from '@/shared/utils/dynamicSort';

const establishmentKey = value => (value || '').replace(/[^0-9]/g, '');

angular.module('cxRelations').directive('cxRelNaceCodes', function() {
  return {
    restrict: 'E',
    template: require('./relNaceCodes.html'),
    scope: {
      field: '=',
      relation: '=',
      naceCodes: '=data',
      disabled: '<?',
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: [
      'flySvc',
      '$http',
      'appUrls',
      '$timeout',
      '$element',
      '$translate',
      '$scope',
      function(flySvc, $http, appUrls, $timeout, $element, $translate, $scope) {
        var vm = this;

        vm.adding = false;
        vm.groups = [];
        // 'E' restricts the first digit to 2-8: 0 and 1 are enterprise numbers, not establishments
        vm.maskOptions = {
          clearOnBlur: false,
          maskDefinitions: { E: /[2-8]/ },
        };

        // Set to have the group of that establishment number opened on the next rebuild, so a code
        // that just moved into a collapsed group does not silently disappear
        var expandKey = null;

        vm.rebuildGroups = () => {
          const wasCollapsed = {};
          vm.groups.forEach(group => {
            wasCollapsed[group.key] = group.collapsed;
          });

          const groupsByKey = {};
          const groups = [];
          (vm.naceCodes || []).forEach(naceCode => {
            const key = establishmentKey(naceCode.establishmentNumber);
            let group = groupsByKey[key];
            if (!group) {
              const collapsed = wasCollapsed[key];
              group = {
                key,
                establishmentNumber: naceCode.establishmentNumber,
                items: [],
                collapsed: !!key && key !== expandKey && collapsed !== false,
              };
              groupsByKey[key] = group;
              groups.push(group);
            }
            group.items.push(naceCode);
          });

          groups.forEach(group => group.items.sort(dynamicSortMultiple('classification', 'code')));
          groups.sort(dynamicSort('key'));

          vm.groups = groups;
          expandKey = null;
        };

        $scope.$watch(
          () =>
            (vm.naceCodes || [])
              .map(x => `${x.id}:${establishmentKey(x.establishmentNumber)}`)
              .join('|'),
          vm.rebuildGroups,
        );

        vm.renewNew = () => {
          vm.newNaceCode = {
            code: null,
            classification: null,
            establishmentNumber: null,
          };
        };
        vm.renewNew();

        vm.addNaceCode = () => {
          vm.adding = true;
          vm.renewNew();
          $timeout(function() {
            $element
              .find('#newNaceCode>.input-group>input.form-control')
              .filter(':visible')
              .last()
              .focus();
          }, 200);
        };

        vm.cancelNew = () => {
          vm.adding = false;
          vm.renewNew();
        };

        vm.submitNewNaceCode = () => {
          if (!vm.newNaceCode.code) return;
          vm.saving = true;
          return $http
            .post(`${appUrls.api}/api/RelationNace/${vm.relation.id}`, vm.newNaceCode)
            .then(
              ({ data }) => {
                if (!vm.naceCodes) vm.naceCodes = [];
                expandKey = establishmentKey(data.establishmentNumber);
                vm.naceCodes.push(data);
                vm.saving = false;
                vm.adding = false;
                vm.renewNew();
                flySvc.success();
              },
              error => {
                flySvc.error(error);
                vm.saving = false;
              },
            );
        };

        vm.update = function(item, field, data) {
          //Incomplete entry in the input mask
          if (typeof data === 'undefined') {
            flySvc.message('msgIncompleteEntryInMaskIsNoSave');
            return '';
          }

          // No change
          if (angular.equals(item[field], data)) return false;

          var model = angular.copy(item);
          model[field] = data;
          return $http.put(`${appUrls.api}/api/RelationNace/${vm.relation.id}`, model).then(
            ({ data: updated }) => {
              if (field === 'establishmentNumber') {
                expandKey = establishmentKey(updated.establishmentNumber);
              }
              angular.extend(item, updated);
              flySvc.success();
              return false;
            },
            error => {
              flySvc.error(error);
              return '';
            },
          );
        };

        vm.delete = function(item) {
          if (!item || !item.id) return;

          vm.deleting = true;
          return $http.delete(`${appUrls.api}/api/RelationNace/${vm.relation.id}/${item.id}`).then(
            result => {
              const idx = (vm.naceCodes || []).indexOf(item);
              if (idx >= 0) vm.naceCodes.splice(idx, 1);
              vm.deleting = false;
              flySvc.success();
            },
            error => {
              flySvc.error(error);
              vm.deleting = false;
            },
          );
        };

        vm.getEstablishmentKboUrl = function(item) {
          if (!item) return null;
          if (!item.establishmentNumber) return null;
          const stripped = item.establishmentNumber.replace(/[^0-9]/g, '');
          if (!stripped) return null;
          const lang = $translate.use().split('-')[0];
          return `https://kbopub.economie.fgov.be/kbopub/toonvestigingps.html?vestigingsnummer=${stripped}${
            lang ? `&lang=${lang}` : ''
          }`;
        };
      },
    ],
  };
});
